import { html } from '@codemirror/lang-html';
import { EditorView } from '@codemirror/view';
import { Box, UnstyledButton } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
import CodeMirror from '@uiw/react-codemirror';
import { Check, Copy } from 'lucide-react';
import type { FC } from 'react';

type TScriptClipboardProps = {
	scriptValue: string;
};

const DarkScriptClipboard: FC<TScriptClipboardProps> = ({
	scriptValue = `<script>
  let newoBot = {
    botId: "abc123xyz",
    position: "bottom-right",
    primaryColor: "#f97316",
    greeting: "Hi! How can I help you today?"
  };
</script>`
}) => {
	const clipboard = useClipboard();

	const handleCopy = () => clipboard.copy(scriptValue);

	return (
		<Box className="relative w-full sm:w-[480px]">
			<UnstyledButton
				className="absolute top-3 right-3 bg-white/10 hover:bg-white/20
                   border border-white/20 rounded-[6px] px-[8px] py-[4px]
                   flex items-center gap-[4px] transition !z-10"
				onClick={handleCopy}
			>
				{clipboard.copied ? (
					<Check className="w-4 h-4 text-white" />
				) : (
					<Copy className="w-4 h-4 text-white" />
				)}
			</UnstyledButton>

			<Box
				className="bg-[#1E1E1E] text-[#F8F8F2] rounded-[10px] p-[20px]
                   font-mono text-[14px] leading-[20px] overflow-auto"
			>
				<CodeMirror
					extensions={[html(), EditorView.lineWrapping]}
					theme="dark"
					value={scriptValue}
				/>
			</Box>
		</Box>
	);
};

export default DarkScriptClipboard;
